import React from 'react';
import classnames from 'classnames';
import { bool, node, string, func, element } from 'prop-types';
import { ButtonIcon } from './../icon';
import withLoading from '../wrappers/withLoading';

const Dialog = ({
  children,
  open,
  scrollable,
  className,
  title,
  buttons,
  onClose,
  loading,
  loadingComponent,
  ...props
}) => (
  <div className={classnames('mdc-dialog', className, { 'mdc-dialog--open': open })} {...props}>
    <div className="mdc-dialog__surface">
      {loadingComponent}
      {title && (
        <header className="mdc-dialog__header">
          <h2 className="mdc-dialog__header__title">{title}</h2>
          {onClose && <ButtonIcon onClick={onClose}>close</ButtonIcon>}
        </header>
      )}
      <section
        className={classnames(
          'mdc-dialog__body',
          { 'mdc-dialog__body--scrollable': scrollable },
        )}
      >
        {children}
      </section>
      {buttons && (
        <footer className="mdc-dialog__footer">
          {buttons}
        </footer>
      )}
    </div>
  </div>
);

Dialog.propTypes = {
  children: node.isRequired,
  buttons: node,
  title: string,
  open: bool,
  scrollable: bool,
  onClose: func,
  loadingComponent: element.isRequired,
};

Dialog.defaultProps = {
  open: true,
  scrollable: false,
  buttons: null,
  onClose: null,
  title: null,
};

export default withLoading()(Dialog);
